module.exports = __webpack_public_path__ + "static/img/call-pass.814d3588.png";